
<template>
  <modal
      name="showModal"
      classes="v-modal-sec" :min-width="200" :min-height="200" :scrollable="true"
      :reset="true" width="450px" height="auto"
    >
      <div class="v-modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">{{actionType === 'CASE_APPROVE' ? 'Approve' : 'Reject'}}</h2>
          <span @click="hideMe">
            <em class="material-icons">close</em> 
          </span>
        </div>
        <form data-vv-scope="submittForm" @submit.prevent @keydown.enter.prevent>
        <div class="form-container">
          <div class="vx-row">
            <div class="vx-col w-full">
              <datepickerField  v-if="actionType === 'CASE_APPROVE'" wrapclass="md"  cid="First Day of Employment"
                :display="true" v-model="firstEmpDate" :formscope="'submittForm'"
                fieldName="  " label="First Day of Employment" :validationRequired="true" />
              <div class="form_group mb-4">
                <label class="form_label">Comment<em>{{actionType === 'CASE_APPROVE' ?'':'*'}}</em></label>
                <ckeditor data-vv-as="Comments"
                  v-validate="actionType === 'CASE_APPROVE' ?'':'required'"
                  v-model="comments"
                  name="comments"
                  class="w-full"  :editor="editor" :config="editorConfig"></ckeditor>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('submittForm.comments')"
                  >{{ errors.first("submittForm.comments") }}</span
                >
              </div>
            </div>
          </div>
          <div class="text-danger text-sm formerrors mt-2" v-show="formErrors">
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ formErrors }}</vs-alert
            >
          </div>
        </div>
        <div class="popup-footer relative">
          <figure v-if="loading" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
          <vs-button color="dark" @click="hideMe" class="cancel" type="filled">Cancel</vs-button>
          <vs-button :disabled="loading" color="success" @click="submitForm()" class="save" type="filled">Submit</vs-button>
        </div>
      </form>
        </div>
    </modal> 
  </template>
  <script>
  import moment from 'moment'
  import Vue from 'vue';
  Vue.use( CKEditor );
  import CKEditor from '@ckeditor/ckeditor5-vue2';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import datepickerField from "@/views/forms/fields/datepicker.vue";
  
  export default {
    inject: ["parentValidator"],
    created() {
        this.$validator = this.parentValidator;
    },
    methods: {
      submitForm() {
           this.formErrors ='';
           this.$validator.validateAll("submittForm").then((result) => {
              if (result) {
                let postData = {
                    i9Id: this.checkProperty(this.caseDetails, '_id' ),
                    reason: this.comments,
                    action:'', 
                };
                 this.loading =true;
                 let path ="/i9/approve-or-reject";
                 if(this.actionType === 'CASE_APPROVE'){
                    postData['action'] = 'Approve'
                    postData['firstEmpDate'] = this.firstEmpDate
                  }else{
                    postData['action'] = 'Reject'
                  }
                 this.$store
                .dispatch("commonAction", {"data":postData ,"path":path})
                .then(response => {
                   this.showToster({message:response.message,isError:false });
                   this.showPopup =false;
                   this.$modal.hide('showModal')
                   this.loading =false;
                   this.$emit("updatepetition", "Case Details");
                   this.$emit("hideMe");                
                })
                .catch((error)=>{
                  this.loading =false;
                  this.formErrors =error;
                })
              }
            });
      },
      hideMe() {
        this.$emit("hideMe");
      },
    },
    watch: {
      showPopup(val) {
        if (!val) this.$emit("hideMe");
      },
    },
    mounted() {
      //this.loading = true;
      this.$modal.show('showModal')
    },
    data: () => ({
      editor: ClassicEditor,
   editorConfig: {
       toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
   },
    formErrors:"",
      loading:false,
      showPopup: false,
      comments: '',
      formerrors: {
        msg: "",
      },
    }),
    props: {
      actionType: {
        type: String,
        default: null,
      },
      isCaseNumberEdit: {
        type: Boolean,
        default: false,
      },
      caseDetails: {
        type: Object,
        default: null,
      },
    },
  components: {
    datepickerField,
  },
  };
  </script>